import moment from "moment";
const currentDate = moment().format("DD-MM-YYYY");

export default {
    address: "",
    assigned_manager: "",
    assigned_operatives: [],
    assigned_supervisor: "",

    end_date: currentDate,
    event_id: "",
    job_name: "",
    job_id: "",
    location_lat: "53.35046029646121",
    location_long: "-6.2605484635565745",
    start_date: currentDate,
    job_vehicles: [],
    job_equipment: [],
    department: null,
    area: null,
    qr_code_url: "",
};
